import ExpenseMainComponent from "../components/ExpenseMainComponent";
import useExpenseMainComponent from "../hook/useExpenseMainComponent";

const ExpenseMainPage = () => {
    const useExpenseMainComponentProps = useExpenseMainComponent();
    return (
        <ExpenseMainComponent {...useExpenseMainComponentProps} />
    )
}

export default ExpenseMainPage;